import React, {ReactNode} from 'react';

// helpers
import parse, {
  domToReact,
  HTMLReactParserOptions,
  DOMNode,
} from 'html-react-parser';

// styles
import {LinkPrimary, TextDefault} from '../../../shared/styles';
import {ArticleParagraph} from '../ArticleDetailsPage-styles';

/**
 * Parse HTML content and replace links with styled components
 * @param htmlContent
 */
export function parseHtml(htmlContent: string): ReactNode {
  const options: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
      if (domNode.type !== 'tag') {
        return;
      }

      if (domNode.name === 'a') {
        return (
          <LinkPrimary
            href={domNode.attribs.href}
            target={domNode.attribs.target ?? '_blank'}
            rel={domNode.attribs.rel ?? 'noopener noreferrer'}>
            {domToReact(domNode.children as DOMNode[], options)}
          </LinkPrimary>
        );
      }

      if (domNode.name === 'p') {
        return (
          <ArticleParagraph as={domNode.name}>
            {domToReact(domNode.children as DOMNode[], options)}
          </ArticleParagraph>
        );
      }

      if (domNode.name === 'li') {
        return (
          <TextDefault as={domNode.name}>
            {domToReact(domNode.children as DOMNode[], options)}
          </TextDefault>
        );
      }
    },
  };

  return parse(htmlContent, options);
}
